import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52f456a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

import { onUnmounted, ref } from 'vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  CoreServiceData,
  CoreServicesService
} from '@/views/dashboard/manage/run-status/_components/core-services/core-services.service'
import {
  ServerStatus,
  ServerStatusLabel,
  resolveServerStatusColor,
} from '@/views/dashboard/manage/run-status/_components/core-services/_enums/server-status'
import LogDrawer from '@/views/dashboard/manage/run-status/_components/core-services/log-drawer/log-drawer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'core-services',
  setup(__props) {

const injector = useReflectiveInjector([CoreServicesService])
const coreServicesService = injector.get(CoreServicesService)

const isLoading = ref(false)
const isLogDrawerVisible = ref(false)
const currentRow = ref<CoreServiceData>({} as CoreServiceData)
const tableData = ref<CoreServiceData[]>([])
let loopDataInterval

function startLoopData () {
  clearInterval(loopDataInterval)
  const intervalFn = () => {
    coreServicesService.getCoreService().then((response) => {
      const list = response.data || []
      if (!list.find(v => v.status === ServerStatus.starting)) {
        clearInterval(loopDataInterval)
        tableData.value = list
      }
    })
  }
  loopDataInterval = setInterval(intervalFn, 5000)
}

function updateData () {
  isLoading.value = true
  return coreServicesService.getCoreService().then(response => {
    const list = response.data || []
    tableData.value = list
    if (list.find(v => v.status === ServerStatus.starting)) {
      startLoopData()
    }
  }).finally(() => {
    isLoading.value = false
  })
}

function rerun (item: CoreServiceData) {
  if (item.status === ServerStatus.starting) {
    return
  }
  ElMessageBox.confirm('是否确定重启?', '提示', {
    confirmButtonText: '重启'
  }).then(() => {
    confirmRerun(item)
  })
}

function confirmRerun (item: CoreServiceData) {
  isLoading.value = true
  coreServicesService.restartService({
    core_service_id: item.core_service_id
  }).then(() => {
    ElMessage.success('操作成功，正在重启...')
    updateData()
    startLoopData()
  }).catch(() => {
    ElMessage.error('操作失败')
  }).finally(() => {
    isLoading.value = false
  })
}

function showLogDrawer (item: CoreServiceData) {
  isLogDrawerVisible.value = true
  currentRow.value = item
}

updateData()

onUnmounted(() => {
  clearInterval(loopDataInterval)
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(Card, {
    title: "核心服务",
    class: "overall-run-wrap"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: tableData.value,
        width: "100%",
        height: "100%",
        "empty-text": _ctx.$t('common.noData')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "序号",
            "min-width": "100"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.$index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "名称",
            "min-width": "200",
            prop: "threat_level"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.name || '--'), 1)
            ]),
            _: 1
          }),
          (0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                "min-width": "200",
                label: "CPU",
                prop: "cpu_usage",
                sortable: ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(+scope.row.cpu_usage.toFixed(1) || 0) + "% ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                "min-width": "200",
                label: "内存(MB)",
                prop: "used_memory_mb",
                sortable: ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.used_memory_mb || 0), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            "min-width": "90",
            label: "状态"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                style: _normalizeStyle({ color: _unref(resolveServerStatusColor)(scope.row.status) })
              }, _toDisplayString(_unref(ServerStatusLabel)[_unref(ServerStatus)[scope.row.status]]), 5)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            label: "操作",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass(["cm-link operate-button", { disabled: scope.row.status === _unref(ServerStatus).starting }]),
                onClick: ($event: any) => (rerun(scope.row))
              }, " 重启服务 ", 10, _hoisted_1),
              _createElementVNode("span", {
                class: "cm-link operate-button",
                onClick: ($event: any) => (showLogDrawer(scope.row))
              }, "查看日志", 8, _hoisted_2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "empty-text"]),
      _createVNode(LogDrawer, {
        "service-data": currentRow.value,
        modelValue: isLogDrawerVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLogDrawerVisible).value = $event))
      }, null, 8, ["service-data", "modelValue"])
    ]),
    _: 1
  })), [
    [_directive_loading, isLoading.value]
  ])
}
}

})